import React from 'react';
import {useSelector} from 'react-redux';
import {Navigate} from 'react-router-dom';
import {useLoggedInUser} from '../../ui/pages/auth/queries';
import {isLoggedInSelector} from '../../store/selectors/auth.selectors';

export function AuthRedirectRoute({redirectTo = '/', children}: {redirectTo?: string; children: JSX.Element}): JSX.Element {
    const isLoggedIn = useSelector(isLoggedInSelector);

    useLoggedInUser();

    if (isLoggedIn) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
}
